import fetch from './fetch';
import { InvoiceApi } from './invoice.types';

export const getInvoice = (studentid: string, invoiceid: string): InvoiceApi => {
  return fetch('GET', `/invoice/${studentid}/${invoiceid}`);
};
